import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

import logger from './plugins/Logger';
import notify from './plugins/Notify';
import dark from './plugins/Dark';

import Icon from '@zfk/fa-icon-library'
//import VueSignalR from './services/signalR'

// import './registerServiceWorker'

import './assets/scss/theme.scss';

Vue.config.productionTip = false

//Vue.use(VueSignalR, process.env.VUE_APP_CHAT_HUB);
Vue.use(logger)
Vue.use(notify)
Vue.use(dark)

Vue.component('Icon', Icon);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  /*created() {
    this.$socket.start({
      log: true
    });
  },*/
}).$mount('#app')
